var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
import { __decorate, __metadata } from "tslib";
import { ElMessage } from 'element-plus';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/hrgs/dashboard/DashboardEnum';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { TDashboardSummaryReport } from '@/core/types/entities/hrgs/dashboard/DashboardEntities';
import { TPaginate } from '@/core/types/commons';
import { Pagination } from '@/core/enums/Pagination';
import { addingLocalFromUtc, getUtcDifferentWithLocal } from '@/core/helpers/date-format';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/assessments`,
    assessors: `${API_URL}/api/assessors`
};
const initialFilters = () => {
    return {
        startDtate: '',
        endDate: '',
        testPlaceIds: [],
        schemeIds: [],
        isCompetent: '',
        condition: ''
    };
};
let DashboardReportModule = class DashboardReportModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.dashboardSummaryReport = {
            totalAssessor: 0,
            totalCertification: 0,
            totalRequest: 0
        };
        this.dashboardSchemaReport = [];
        this.dashboardTestPlaceReport = {
            data: [],
            pagination: {
                totalPage: 0,
                totalPageSize: 0,
                startPaginationIndex: 0,
                endPaginationIndex: 0,
                currentPage: 1
            }
        };
        this.dashboardTestPlaceParticipantReport = {
            data: [],
            pagination: {
                totalPage: 0,
                totalPageSize: 0,
                startPaginationIndex: 0,
                endPaginationIndex: 0,
                currentPage: 1
            }
        };
        this.dashboardSchemaDetailsAssesorReport = {
            data: [],
            pagination: {
                totalPage: 0,
                totalPageSize: 0,
                startPaginationIndex: 0,
                endPaginationIndex: 0,
                currentPage: 1
            }
        };
        this.dashboardResultSummariesReport = [];
        this.dashboardResultDetailReport = {
            data: [],
            pagination: {
                totalPage: 0,
                totalPageSize: 0,
                startPaginationIndex: 0,
                endPaginationIndex: 0,
                currentPage: 1
            }
        };
        this.filters = initialFilters();
    }
    // *GETTERS
    get getDashboardSummaryReport() {
        return this.dashboardSummaryReport;
    }
    get getDashboardSchemaReport() {
        return this.dashboardSchemaReport;
    }
    get getDashboardTestPlaceReport() {
        return this.dashboardTestPlaceReport;
    }
    get getDashboardTestPlaceParticipantReport() {
        return this.dashboardTestPlaceParticipantReport;
    }
    get getDashboardSchemaDetailsAssesorReport() {
        return this.dashboardSchemaDetailsAssesorReport;
    }
    get getDashboardResultSummariesReport() {
        return this.dashboardResultSummariesReport;
    }
    get getDashboardResultDetailReport() {
        return this.dashboardResultDetailReport;
    }
    get getDashboardFilter() {
        return this.filters;
    }
    // *MUTATIONS
    [_a = Mutations.SET_SUMMARY_REPORT](data) {
        this.dashboardSummaryReport = data;
    }
    [_b = Mutations.SET_SCHEMA_REPORT](data) {
        this.dashboardSchemaReport = data;
    }
    [_c = Mutations.SET_TEST_PLACE_SUMMARIES_REPORT](data) {
        this.dashboardTestPlaceReport = data;
    }
    [_d = Mutations.SET_TEST_PLACE_PARTICIPANT_REPORT](data) {
        this.dashboardTestPlaceParticipantReport = data;
    }
    [_e = Mutations.RESET_TEST_PLACE_PARTICIPANT_REPORT]() {
        this.dashboardTestPlaceParticipantReport = {
            data: [],
            pagination: {
                totalPage: 0,
                totalPageSize: 0,
                startPaginationIndex: 0,
                endPaginationIndex: 0,
                currentPage: 1
            }
        };
    }
    [_f = Mutations.SET_SCHEMA_DETAILS_ASESOR_REPORT](data) {
        this.dashboardSchemaDetailsAssesorReport = data;
    }
    [_g = Mutations.SET_RESULT_SUMMARIES_REPORT](data) {
        this.dashboardResultSummariesReport = data;
    }
    [_h = Mutations.SET_RESULT_DETAIL_REPORT](data) {
        this.dashboardResultDetailReport = data;
    }
    [_j = Mutations.SET_FILTERS](data) {
        this.filters = Object.assign(Object.assign({}, this.filters), data);
    }
    [_k = Mutations.CLEAR_FILTER]() {
        this.filters = initialFilters();
    }
    // *ACTIONS
    [_l = Actions.GET_SUMMARY_REPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign({}, setPayloadFilters(this.filters).params), { ver: 'v1' });
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/summaries?${new URLSearchParams(params).toString() || ''}&${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_SUMMARY_REPORT, resData);
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Summary Report.'
                });
                reject(error);
            });
        });
    }
    [_m = Actions.GET_SCHEMA_REPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign({}, setPayloadFilters(this.filters).params), { ver: 'v1' });
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/schemes/summaries?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_SCHEMA_REPORT, resData);
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    [_o = Actions.GET_TEST_PLACE_SUMMARIES_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign({}, setPayloadFilters(this.filters).params), { ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO });
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/testPlaces/summaries?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                const { pagination } = this.dashboardTestPlaceReport;
                const totalPage = resData.totalRecords || 0;
                const totalPageSize = params.pageSize || pagination.totalPageSize;
                const currentPage = params.pageNo || pagination.currentPage;
                this.context.commit(Mutations.SET_TEST_PLACE_SUMMARIES_REPORT, {
                    data: resData.data,
                    pagination: Object.assign(Object.assign({}, pagination), { totalPage,
                        totalPageSize,
                        currentPage, startPaginationIndex: 0, endPaginationIndex: Math.floor(totalPage / totalPageSize) })
                });
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard TUK Report.'
                });
                reject(error);
            });
        });
    }
    [_p = Actions.GET_TEST_PLACE_PARTICIPANT_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign({}, setPayloadFilters(this.filters).params), { ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO });
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/testPlaces/${payload === null || payload === void 0 ? void 0 : payload.testPlaceId}/participants?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                const { pagination } = this.dashboardTestPlaceParticipantReport;
                const totalPage = resData.totalRecords || 0;
                const totalPageSize = params.pageSize || pagination.totalPageSize;
                const currentPage = params.pageNo || pagination.currentPage;
                this.context.commit(Mutations.SET_TEST_PLACE_PARTICIPANT_REPORT, {
                    data: resData.data,
                    pagination: Object.assign(Object.assign({}, pagination), { totalPage,
                        totalPageSize,
                        currentPage, startPaginationIndex: 0, endPaginationIndex: Math.floor(totalPage / totalPageSize) })
                });
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    [_q = Actions.GET_SCHEMA_SUMMARIES_ASESOR_REPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.assessors}/${employeeID}/reports/schemes/summaries?${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_SCHEMA_REPORT, resData);
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    [_r = Actions.GET_SCHEMA_DETAIL_ASESOR_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.assessors}/${employeeID}/reports/schemes/${payload === null || payload === void 0 ? void 0 : payload.schemeId}?${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                const { pagination } = this.dashboardSchemaDetailsAssesorReport;
                const totalPage = resData.totalRecords || 0;
                const totalPageSize = params.pageSize || pagination.totalPageSize;
                const currentPage = params.pageNo || pagination.currentPage;
                this.context.commit(Mutations.SET_SCHEMA_DETAILS_ASESOR_REPORT, {
                    data: resData.data,
                    pagination: Object.assign(Object.assign({}, pagination), { totalPage,
                        totalPageSize,
                        currentPage, startPaginationIndex: 0, endPaginationIndex: Math.floor(totalPage / totalPageSize) })
                });
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    [_s = Actions.GET_RESULT_SUMMARIES_REPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign({ ver: 'v1' }, setPayloadFilters(this.filters).params);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/results/summaries?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_RESULT_SUMMARIES_REPORT, resData);
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    [_t = Actions.GET_RESULT_DETAIL_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign({ ver: 'v1' }, setPayloadFilters(this.filters).params), { pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO });
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/results/${payload === null || payload === void 0 ? void 0 : payload.isCompetent}/competencyUnits?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                const { pagination } = this.dashboardSchemaDetailsAssesorReport;
                const totalPage = resData.totalRecords || 0;
                const totalPageSize = params.pageSize || pagination.totalPageSize;
                const currentPage = params.pageNo || pagination.currentPage;
                this.context.commit(Mutations.SET_RESULT_DETAIL_REPORT, {
                    data: resData.data,
                    pagination: Object.assign(Object.assign({}, pagination), { totalPage,
                        totalPageSize,
                        currentPage, startPaginationIndex: 0, endPaginationIndex: Math.floor(totalPage / totalPageSize) })
                });
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Schema Report.'
                });
                reject(error);
            });
        });
    }
    // *EXPORT DASHBOARD REPORT LIST DATA
    [_u = Actions.EXPORT_RESULT_DETAIL_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign({ ver: 'v1' }, setPayloadFilters(this.filters).params);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/results/${payload === null || payload === void 0 ? void 0 : payload.isCompetent}/competencyUnits/export?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(params).toString() || ''}`
            // `${API_URLS.url}/${employeeID}/reports/results/${payload?.isCompetent}/competencyUnits/export?${setPayloadFilters(this.filters).schemeIds}&${setPayloadFilters(this.filters).testPlaceIds}&${new URLSearchParams(
            //   params,
            // ).toString()}`,
            )
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD DASHBOARD REPORT LIST DATA
    [_v = Actions.DOWNLOAD_RESULT_DETAIL_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/reports/results/${payload === null || payload === void 0 ? void 0 : payload.isCompetent}/competencyUnits/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    [_w = Actions.GET_ASSESSMENT_SCHEMA]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/schemes?${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Summary Report.'
                });
                reject(error);
            });
        });
    }
    [_x = Actions.GET_ASSESSMENT_TEST_PLACE]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/testPlaces?${new URLSearchParams(params).toString() || ''}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Summary Report.'
                });
                reject(error);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_y = typeof TDashboardSummaryReport !== "undefined" && TDashboardSummaryReport) === "function" ? _y : Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_z = typeof TPaginate !== "undefined" && TPaginate) === "function" ? _z : Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_0 = typeof TPaginate !== "undefined" && TPaginate) === "function" ? _0 : Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_1 = typeof TPaginate !== "undefined" && TPaginate) === "function" ? _1 : Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_2 = typeof TPaginate !== "undefined" && TPaginate) === "function" ? _2 : Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _w, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _x, null);
DashboardReportModule = __decorate([
    Module
], DashboardReportModule);
export default DashboardReportModule;
const setPayloadFilters = (filters) => {
    return {
        schemeIds: `SchemeIds=${filters === null || filters === void 0 ? void 0 : filters.schemeIds.join('&SchemeIds=')}`,
        testPlaceIds: `TestPlaceIds=${filters === null || filters === void 0 ? void 0 : filters.testPlaceIds.join('&TestPlaceIds=')}`,
        params: Object.assign(Object.assign(Object.assign(Object.assign({}, ((filters === null || filters === void 0 ? void 0 : filters.condition) && {
            Condition: filters.condition
        })), ((filters === null || filters === void 0 ? void 0 : filters.isCompetent) && {
            IsCompetent: filters.isCompetent
        })), ((filters === null || filters === void 0 ? void 0 : filters.date) && {
            StartDate: addingLocalFromUtc(filters.date.split(',')[0]),
            EndDate: addingLocalFromUtc(filters.date.split(',')[1])
        })), { gmt: String(getUtcDifferentWithLocal()) })
    };
};
